import { useEffect, useState } from "react";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  getAllProjectMembers,
  getAllProjectStatus,
  getEditDataProjectForm,
  setProjectStatus,
} from "../../../API/store/actions/projects/projects";
import ModalComponent from "../../reusableComponents/modal";
import Bullets from "../../sharedComponents/bullets/bullets";
import Button from "../../sharedComponents/buttons/button";
import ProjectStatusCard from "./projectStatusCard";
import Lang from "../../../userPreferences/staticWords";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";

const EditProjectStatus = ({
  projectId,
  procAdded,
  setProcAdded,
  userToken,
}) => {
  const [members, setMembers] = useState(null);
  const [modalVisible, setModalVisible] = useState(null);
  const [StatusId, setStatusId] = useState(null);
  const [changeAll, setChangeAll] = useState(false);

  const modalVisibleFunc = (id) => {
    setStatusId(id);
    setModalVisible(true);
  };

  const [status, setStatus] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [proj, setProj] = useState(null);

  useEffect(() => {
    setStatus(null);
    resolver(getAllProjectMembers, setMembers, projectId, userToken);
    resolver(getAllProjectStatus, setStatus, userToken);
    resolver(getEditDataProjectForm, setProj, projectId, userToken);
  }, []);

  useEffect(() => {
    setProjectStatus(
      projectId,
      changeAll,
      currentStatus,
      resolver,
      getAllProjectMembers,
      setMembers,
      userToken
    );
  }, [currentStatus]);

  return (
    <>
      <ModalComponent
        body={
          <ProjectStatusAlert
            id={StatusId}
            setValue={setCurrentStatus}
            setVisible={setModalVisible}
            setChangeAll={setChangeAll}
            procAdded={procAdded}
            setProcAdded={setProcAdded}
          />
        }
        size={"s"}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        hasIcon
        title={
          getDir(getCurrentLangFromRedux()) == "rtl"
            ? "هل انت متاكد ؟"
            : "Are you sure ?"
        }
        background={"modalBackground mx-5"}
      />
      <div className="mx-5 ">
        <div className="d-flex flex-column flex-lg-row justify-content-between mx-3">
          <div style={{ fontSize: 18 }}>{proj?.data?.nameA}</div>
          <div className="d-flex align-items-center justify-content-center col-lg-3 col-12 mt-lg-0 mt-4">
            {status?.data?.statusLkp.map((item, index) => {
              return (
                <div className=" d-flex flex-column justify-content-center align-items-center mx-2">
                  <Bullets
                    key={index}
                    containerStyle={{ width: 21 }}
                    memberId={proj?.data?.id}
                    id={item?.id}
                    borderColor={"#1a73e8"}
                    bulletColor={item?.color}
                    tooltipTitle={item?.name}
                    setActive={modalVisibleFunc}
                    procAdded={procAdded}
                    setProcAdded={setProcAdded}
                    active={currentStatus ?? proj?.data?.projectStatusId}
                  />

                  <div className=" text-center">{item.name}</div>
                </div>
              );
            })}
          </div>
        </div>
        {members?.data?.adminmember?.length > 0 ||
        members?.data?.member?.length > 0 ? (
          <div
            className="my-3  px-2"
            style={{
              boxShadow: "1px 2px 7px grey",
              height: 400,
              overflowY: "auto",
            }}
          >
            <div className="p-3" style={{ color: "#1a73e8" }}>
              {Lang.Members}
            </div>

            {members?.data?.adminmember?.length > 0 ? (
              <div className="px-5 ">
                <div className="my-3">{Lang.adminMembers}</div>
                {members?.data?.adminmember.map((item, index) => {
                  return (
                    <ProjectStatusCard
                      key={index}
                      member={item}
                      status={status}
                      procAdded={procAdded}
                      setProcAdded={setProcAdded}
                      userToken={userToken}
                      projectId={projectId}
                    />
                  );
                })}
              </div>
            ) : null}
            {members?.data?.member?.length > 0 ? (
              <div className="px-5 ">
                <div className="my-3">{Lang.Members}</div>
                {members?.data?.member.map((item, index) => {
                  return (
                    <ProjectStatusCard
                      key={index}
                      member={item}
                      status={status}
                      procAdded={procAdded}
                      setProcAdded={setProcAdded}
                      userToken={userToken}
                      projectId={projectId}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
};
export default EditProjectStatus;

const ProjectStatusAlert = ({
  setVisible,
  setValue,
  id,
  setChangeAll,
  procAdded,
  setProcAdded,
}) => {
  return (
    <div className=" d-flex flex-column  align-items-center justify-content-center">
      <img src="/assets/images/fi-br-info.png" />
      <div className="my-2">
        {getDir(getCurrentLangFromRedux()) == "rtl"
          ? "هل تريد تغيير حالة المشاركين أيضًا ؟"
          : "Do you want to change Members status also ?"}
      </div>
      <div className="d-flex justify-content-center flex-wrap w-100 my-3">
        <Button
          containerStyle={"col-3 mx-2 "}
          content={getDir(getCurrentLangFromRedux()) == "rtl" ? "نعم" : "Yes"}
          buttonStyleType={"solid"}
          onClick={() => {
            setProcAdded(!procAdded);
            setValue(id);
            setVisible(false);
            setChangeAll(true);
          }}
        />
        <Button
          containerStyle={"col-3 mx-2"}
          content={getDir(getCurrentLangFromRedux()) == "rtl" ? "لا" : "No"}
          onClick={() => {
            setProcAdded(!procAdded);
            setValue(id);
            setVisible(false);
            setChangeAll(false);
          }}
        />
      </div>
    </div>
  );
};
